import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

const SearchBox = ({ history }) => {
	const [keyword, setKeyword] = useState('')

	const submitHandler = e => {
		e.preventDefault()

		if (keyword.trim()) {
			history.push(`/search/${keyword}`)
		} else {
			history.push('/')
		}
	}

	return (
		<Form onSubmit={submitHandler} inline>
			<Form.Control
				type="text"
				name="q"
				value={keyword}
				placeholder="Search Products"
				className="mr-sm-2 ml-sm-5"
				onChange={e => setKeyword(e.target.value)}
			></Form.Control>
			<Button type="submit" variant="outline-success" className="p-2">
				Search
			</Button>
		</Form>
	)
}

SearchBox.propTypes = {
	history: PropTypes.object.isRequired
}

export default SearchBox
